import React from 'react';
import BaseNode from './BaseBlockNode';
import { makeParams, renderValue } from '../../helpers/node';
import { LoadNodeConfig } from '../../../constants';

function LoadNode(props) {
  const { offlineCurrentLimit } = props;

  return (
    <BaseNode
      {...props}
      staticParams={[{ label: 'Max Offline Load', value: renderValue(offlineCurrentLimit, 'A') }]}
      dynamicParams={makeParams(LoadNodeConfig().dynamicParams)(props)}
    />
  );
}

export default LoadNode;
